import {
  DTOWorkspaceInvitationsResponse,
  DTOWorkspaceInvitationUpdateResponse,
  DTOWorkspaceInviteUpdate,
  DTOWorkspaceResponse,
} from "../../dto";
import { RequestExecutor } from "../../transport";

export class WorkspaceInvitationsEndpoint {
  constructor(private readonly requestExecutor: RequestExecutor) {}

  update(workspaceId: string, invitationId: string, body: DTOWorkspaceInviteUpdate) {
    return this.requestExecutor.json(
      `/workspaces/${workspaceId}/invitations/${invitationId}/role`,
      DTOWorkspaceInvitationUpdateResponse,
      {
        method: "PUT",
        body,
      }
    );
  }

  list(workspaceId: string) {
    return this.requestExecutor.json(`/workspaces/${workspaceId}/invitations`, DTOWorkspaceInvitationsResponse, {
      method: "GET",
    });
  }

  delete(workspaceId: string, invitationId: string) {
    return this.requestExecutor.json(`/workspaces/${workspaceId}/invitations/${invitationId}`, DTOWorkspaceResponse, {
      method: "DELETE",
    });
  }
}
